import { Component, OnInit, Input, ApplicationRef, OnDestroy } from '@angular/core';
import { ReportsService } from '../../data/reports.service';
import { MatDialog } from '@angular/material/dialog';
import {SalespersonTransactionsDialogComponent} from '../salesperson-transactions-dialog/salesperson-transactions-dialog.component';
import { SaleStat } from '../../data/sale-stat';
import { Observable, Subscription, timer } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { LocalStorage } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { LineChartQuery } from '../../data/line-chart.query';
import moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-graph-total-info',
  templateUrl: './graph-total-info.component.html',
  styleUrls: ['./graph-total-info.component.scss'],
  providers: [DeviceDetectorService]
})
export class GraphTotalInfoComponent implements OnInit, OnDestroy {
  @Input()
  usersInfo: SaleStat[]

  @LocalStorage()
  hiddenUsersIds: number[]

  @Input()
  startDate: string;

  @Input()
  finishDate: string;

  loadingSpinner = false;

  isMobile: boolean;

  chartType: string

  private eventsSubscription: Subscription;

  constructor(
    private deviceDetector: DeviceDetectorService,
    protected reportsService: ReportsService,
    protected lineChartQuery: LineChartQuery,
    protected dialog: MatDialog,
    protected appRef: ApplicationRef,
    protected router: Router
  ) {
    this.isMobile = this.deviceDetector.isMobile()
  }

  ngOnInit(): void {
    this.eventsSubscription = this.lineChartQuery.events$
    .pipe(debounceTime(10))
    .subscribe(event => {
      this.updateInfo()
    });

    this.lineChartQuery.chartType$.subscribe(type => {
      this.chartType = type
    })

  }

  updateInfo() {
    if(this.hiddenUsersIds) {
      let usMap = new Map();

      this.hiddenUsersIds.forEach(id => {
        usMap.set(id, 'User')
      })

      this.usersInfo.forEach(info => {
        if(usMap.has(info.salesUser.id)) {
          info.hideUser = true;
          this.reportsService.userFilter$.next(info.salesUser.id)
        }
      })

    }
  }

  openUserWindow(info: SaleStat) {
    if(!this.isMobile) {
      const dialogRef = this.dialog.open(SalespersonTransactionsDialogComponent, {
        data: {
          userId: info.salesUser.id,
          userName: info.salesUser.name,
          startDate: moment(this.startDate).format('YYYY-MM-DD'),
          finishDate: moment(this.finishDate).format('YYYY-MM-DD'),
          info,
          fromSchedule: false
        },
        panelClass: 'user-transactions-modal-dialog',
        disableClose: false
      });
    }
  }

  showHideUser(info: SaleStat) {
    info.hideUser = !info.hideUser;

    this.hiddenUsersIds = this.usersInfo.filter(uinfo => uinfo.hideUser).map(i => i.salesUser.id)


    this.reportsService.userFilter$.next(info.salesUser.id)
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe()
  }
}
